module.exports = __webpack_public_path__ + "static/img/200327.9dfc79a7.png";